import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './pop-up.scss';

const PopUp = props => {
    const reload=()=>window.location.reload();

    return (
      <>
        <Modal show={props.show} onHide={props.resetPopUp} onExit={reload} >
          <Modal.Header>
            <Modal.Title>{props.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{props.body}</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={reload}>
              Try Again
            </Button>
            <Button variant="primary" onClick={props.onContinue}>
              Continue
            </Button>
          </Modal.Footer>
          
        </Modal>
      </>
    )
}

export default PopUp;